// extracted by mini-css-extract-plugin
export default {"container":"Controls_container__iOHCv","oneButton":"Controls_oneButton__6elgL"};